import { PhoneCountry } from '../../models/serializable/phone-country.js';
import { isNullOrUndefined } from '../../utility/null-safety.js';
import { GenericPhoneNumberFormatter } from './generic-phone-number-formatter.js';
import { HungarianPhoneNumberFormatter } from './hungarian-phone-number-formatter.js';
import { PhoneNumberFormatter } from './phone-number-formatter.js';
import { RomanianPhoneNumberFormatter } from './romanian-phone-number-formatter.js';

export class PhoneNumberFormatterFactory {
  static builders: Map<PhoneCountry, PhoneNumberFormatter> = new Map([
    [PhoneCountry.Albania, new GenericPhoneNumberFormatter()],
    [PhoneCountry.Andorra, new GenericPhoneNumberFormatter()],
    [PhoneCountry.Armenia, new GenericPhoneNumberFormatter()],
    [PhoneCountry.Austria, new GenericPhoneNumberFormatter()],
    [PhoneCountry.Azerbaijan, new GenericPhoneNumberFormatter()],
    [PhoneCountry.Belarus, new GenericPhoneNumberFormatter()],
    [PhoneCountry.Belgium, new GenericPhoneNumberFormatter()],
    [PhoneCountry.BosniaAndHerzegovina, new GenericPhoneNumberFormatter()],
    [PhoneCountry.Bulgaria, new GenericPhoneNumberFormatter()],
    [PhoneCountry.Croatia, new GenericPhoneNumberFormatter()],
    [PhoneCountry.Cyprus, new GenericPhoneNumberFormatter()],
    [PhoneCountry.CzechRepublic, new GenericPhoneNumberFormatter()],
    [PhoneCountry.Denmark, new GenericPhoneNumberFormatter()],
    [PhoneCountry.Estonia, new GenericPhoneNumberFormatter()],
    [PhoneCountry.FaroeIslands, new GenericPhoneNumberFormatter()],
    [PhoneCountry.Finland, new GenericPhoneNumberFormatter()],
    [PhoneCountry.France, new GenericPhoneNumberFormatter()],
    [PhoneCountry.Georgia, new GenericPhoneNumberFormatter()],
    [PhoneCountry.Germany, new GenericPhoneNumberFormatter()],
    [PhoneCountry.Gibraltar, new GenericPhoneNumberFormatter()],
    [PhoneCountry.Greece, new GenericPhoneNumberFormatter()],
    [PhoneCountry.Hungary, new HungarianPhoneNumberFormatter()],
    [PhoneCountry.Iceland, new GenericPhoneNumberFormatter()],
    [PhoneCountry.Ireland, new GenericPhoneNumberFormatter()],
    [PhoneCountry.Italy, new GenericPhoneNumberFormatter()],
    [PhoneCountry.Latvia, new GenericPhoneNumberFormatter()],
    [PhoneCountry.Liechtenstein, new GenericPhoneNumberFormatter()],
    [PhoneCountry.Lithuania, new GenericPhoneNumberFormatter()],
    [PhoneCountry.Luxembourg, new GenericPhoneNumberFormatter()],
    [PhoneCountry.NorthMacedonia, new GenericPhoneNumberFormatter()],
    [PhoneCountry.Malta, new GenericPhoneNumberFormatter()],
    [PhoneCountry.RepublicOfMoldova, new GenericPhoneNumberFormatter()],
    [PhoneCountry.Monaco, new GenericPhoneNumberFormatter()],
    [PhoneCountry.Montenegro, new GenericPhoneNumberFormatter()],
    [PhoneCountry.Netherlands, new GenericPhoneNumberFormatter()],
    [PhoneCountry.Norway, new GenericPhoneNumberFormatter()],
    [PhoneCountry.Poland, new GenericPhoneNumberFormatter()],
    [PhoneCountry.Portugal, new GenericPhoneNumberFormatter()],
    [PhoneCountry.Romania, new RomanianPhoneNumberFormatter()],
    [PhoneCountry.Russia, new GenericPhoneNumberFormatter()],
    [PhoneCountry.SanMarino, new GenericPhoneNumberFormatter()],
    [PhoneCountry.Serbia, new GenericPhoneNumberFormatter()],
    [PhoneCountry.Slovakia, new GenericPhoneNumberFormatter()],
    [PhoneCountry.Slovenia, new GenericPhoneNumberFormatter()],
    [PhoneCountry.Spain, new GenericPhoneNumberFormatter()],
    [PhoneCountry.Sweden, new GenericPhoneNumberFormatter()],
    [PhoneCountry.Switzerland, new GenericPhoneNumberFormatter()],
    [PhoneCountry.Turkey, new GenericPhoneNumberFormatter()],
    [PhoneCountry.Ukraine, new GenericPhoneNumberFormatter()],
    [PhoneCountry.UnitedKingdom, new GenericPhoneNumberFormatter()],
    [PhoneCountry.VaticanCity, new GenericPhoneNumberFormatter()],
  ]);

  static ofCountry(country: PhoneCountry): PhoneNumberFormatter {
    const formatter = this.builders.get(country);
    if(isNullOrUndefined(formatter)) {
      throw Error(`Failed to find formatter for country ${country}`);
    }

    return formatter;
  }
}
